import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setReferenciaConsultaConcursoSelecoes: ['referencia'],
    limpaFiltroConsultaConcursoSelecoes: [],
    receberFiltroConsultaConcursoSelecoes: ['filtroRecebido'],
    setStatusConsultaConcursoSelecoes: ['status'],
})

const INITIAL_STATE = {
    referencia: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_CONCURSO_SELECOES]: setReferencia,
    [Types.LIMPA_FILTRO_CONSULTA_CONCURSO_SELECOES]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CONCURSO_SELECOES]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_CONCURSO_SELECOES]: setStatus,
})
